import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ResizeIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path fillRule='evenodd' clipRule='evenodd' d='M16 4V16H4L16 4Z' fill='currentColor' />
        </>
    ),
})

ResizeIcon.displayName = 'ResizeIcon'
